<template>
  <transition appear name="fade">
    <div
      v-if="value"
      class="modal"
      :class="{ 'is-active': value }"
      @keyup.esc="hide()"
      v-on="$listeners"
    >
      <div class="modal-background" @click="hide()"></div>
      <div class="modal-card">
        <header class="modal-card-head">
          <div class="modal-card-title">
            <span class="is-size-5">{{ title }}</span>
            <br />
            <span v-if="subtitle" class="subtitle is-size-6">{{
              subtitle
            }}</span>
          </div>
          <button
            v-if="!hideClose"
            class="delete"
            aria-label="close"
            @click="hide()"
          ></button>
        </header>
        <section class="modal-card-body" id="modal-body">
          <slot name="body"></slot>
        </section>
        <footer class="modal-card-foot right">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "bmodal",
  components: {},
  props: ["value", "hideClose", "title", "subtitle"],
  data() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {},
  beforeDestroy() {},
  methods: {
    hide() {
      this.$emit("input", false);
      this.$emit("hide");
    },
  },
};
</script>

<style lang="css" scoped>
.slide-fade-modal-enter-active {
  transition: all 0.1s ease;
}

.slide-fade-modal-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-modal-enter,
.slide-fade-modal-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
